import { render, staticRenderFns } from "./PcWindow.vue?vue&type=template&id=1619c587"
import script from "./PcWindow.vue?vue&type=script&lang=js"
export * from "./PcWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VWindow } from 'vuetify/lib/components/VWindow';
installComponents(component, {VWindow})
